
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductSpecificationsDialog extends Serenity.EntityDialog<ProductSpecificationsRow, any> {
        protected getFormKey() { return ProductSpecificationsForm.formKey; }
        protected getIdProperty() { return ProductSpecificationsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductSpecificationsRow.localTextPrefix; }
        protected getNameProperty() { return ProductSpecificationsRow.nameProperty; }
        protected getService() { return ProductSpecificationsService.baseUrl; }
        protected getDeletePermission() { return ProductSpecificationsRow.deletePermission; }
        protected getInsertPermission() { return ProductSpecificationsRow.insertPermission; }
        protected getUpdatePermission() { return ProductSpecificationsRow.updatePermission; }

        protected form = new ProductSpecificationsForm(this.idPrefix);

        private loadedState: string;

        constructor() {
            super();

            this.form.EValidityType.changeSelect2(e => {
                var vValidityType = this.form.EValidityType.value;

                if (Q.isEmptyOrNull(vValidityType)) {
                    // this.setProductDetails({});
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);

                }
                else {

                    if (vValidityType == '1' || vValidityType == '2') {

                        if (vValidityType == '2') {
                            this.form.ValidTill.getGridField().toggle(false);
                            this.form.EValidity.getGridField().toggle(true);
                        }
                        else {
                            this.form.ValidTill.getGridField().toggle(true);
                            this.form.EValidity.getGridField().toggle(false);
                        }
                    }

                }

            });
            this.form.Rioplay8EViewsType.changeSelect2(e => {
                var eRioplay8EViewsType = this.form.Rioplay8EViewsType.value;
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                if (eRioplay8EViewsType == '1') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(true);
                }
                else if (eRioplay8EViewsType == '0') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                }
            });
            this.form.Rioplay8EWatchTimetype.changeSelect2(e => {
                var eRioplay8EWatchTimetype = this.form.Rioplay8EWatchTimetype.value;
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                if (eRioplay8EWatchTimetype == '1') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(true);
                }
                else if (eRioplay8EWatchTimetype == '0') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(false);
                }
            });
            this.form.Rioplay8ESubscriptionType.changeSelect2(e => {
                var eRioplay8ESubscriptionType = this.form.Rioplay8ESubscriptionType.value;
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                if (eRioplay8ESubscriptionType == '0') {
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(true);
                }
                else if (eRioplay8ESubscriptionType == '1') {
                    this.form.Rioplay8ValidDate.getGridField().toggle(true);
                }
            });
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }
        loadEntity(entity: ProductsRow) {
            super.loadEntity(entity);

            if (this.isNew()) {

                this.form.ValidTill.getGridField().toggle(false);
                this.form.EValidity.getGridField().toggle(false);
                this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                this.form.Rioplay8EViewsType.getGridField().toggle(false);
                this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                this.form.Rioplay8AllowedDevices.getGridField().toggle(false);
                let productId = this.form.ProductId.value;

                let product = RioERP.Products.ProductsRow.getLookup().itemById[productId];
                if (product.ERioplayVersion != null) {
                    var eRioplayVersion = product.ERioplayVersion.toString();
                }
                if (eRioplayVersion == '4')
                {

                    this.form.Rioplay8ESubscriptionType.getGridField().toggle(true);
                    this.form.Rioplay8EViewsType.getGridField().toggle(true);
                    this.form.Eopens.getGridField().toggle(false);
                    this.form.EWatchtime.getGridField().toggle(false);
                    this.form.Rioplay8EWatchTimetype.getGridField().toggle(true);
                    this.form.Rioplay8AllowedDevices.getGridField().toggle(true);
                    this.form.EValidityType.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.AllowedDevice.getGridField().toggle(false);
                }
                else if (eRioplayVersion != '4') {
                    this.form.EValidityType.getGridField().toggle(true);
                    this.form.EValidity.getGridField().toggle(true);
                    this.form.ValidTill.getGridField().toggle(true);
                    this.form.Rioplay8ValidDate.getGridField().toggle(false);
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                    this.form.AllowedDevice.getGridField().toggle(true);
                }
            }
            else if (this.isEditMode())
            {
                this.form.ValidTill.getGridField().toggle(false);
                this.form.EValidity.getGridField().toggle(false);
           
                this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                this.form.Rioplay8EViewsType.getGridField().toggle(false);
                this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                this.form.Rioplay8AllowedDevices.getGridField().toggle(false);
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
               
                let productId = this.form.ProductId.value;

                let product = RioERP.Products.ProductsRow.getLookup().itemById[productId];
                if (product.ERioplayVersion != null) {
                    var eRioplayVersion = product.ERioplayVersion.toString();
                }
                if (eRioplayVersion == '4') {
                    this.form.Rioplay8ESubscriptionType.getGridField().toggle(true);
                    this.form.Rioplay8EViewsType.getGridField().toggle(true);
                    this.form.Eopens.getGridField().toggle(false);
                    this.form.EWatchtime.getGridField().toggle(false);
                    this.form.Rioplay8EWatchTimetype.getGridField().toggle(true);
                    this.form.Rioplay8AllowedDevices.getGridField().toggle(true);
                    this.form.EValidityType.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.AllowedDevice.getGridField().toggle(false);
                }
                else if (eRioplayVersion != '4') {
                    this.form.EValidityType.getGridField().toggle(true);
                    this.form.EValidity.getGridField().toggle(true);
                    this.form.ValidTill.getGridField().toggle(true);
                    this.form.Rioplay8ValidDate.getGridField().toggle(false);
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                    this.form.AllowedDevice.getGridField().toggle(true);
                }
                var eRioplay8EViewsType = this.form.Rioplay8EViewsType.value;
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                if (eRioplay8EViewsType == '1') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(true);
                }
                else if (eRioplay8EViewsType == '0') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                }
                var eRioplay8EWatchTimetype = this.form.Rioplay8EWatchTimetype.value;
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                if (eRioplay8EWatchTimetype == '1') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(true);
                }
                else if (eRioplay8EWatchTimetype == '0') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(false);
                }
               var eRioplay8ESubscriptionType = this.form.Rioplay8ESubscriptionType.value;
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                if (eRioplay8ESubscriptionType == '0') {
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(true);
                }
                else if (eRioplay8ESubscriptionType == '1') {
                    this.form.Rioplay8ValidDate.getGridField().toggle(true);
                }
            }
            else {

                var vValidityType = this.form.EValidityType.value;

                if (Q.isEmptyOrNull(vValidityType)) {
                    // this.setProductDetails({});
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);

                }
                else {

                    if (vValidityType == '1' || vValidityType == '2')
                    {

                        if (vValidityType == '2') {
                            this.form.ValidTill.getGridField().toggle(false);
                            this.form.EValidity.getGridField().toggle(true);
                        }
                        else if (vValidityType == '1') {
                            this.form.ValidTill.getGridField().toggle(true);
                            this.form.EValidity.getGridField().toggle(false);
                        }
                    }

                }
            }
            
        }

    }
}
